import React, { useContext, useRef } from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { BrandRating } from '../BrandRating/BrandRating';
import * as analytics from '../../analytics';
import { ProductDetailsContext } from '../ProductDetailsContext';

const analyticsData = (event, pageType, element) => {
  analytics.track('click', {
    element
  });
};

const CollectionURL = ({
  link, pageType, showCollection
}) => {

  const { channel } = useContext(ExperienceContext);
  const { product } = useContext(ProductDetailsContext);
  const { url } = product?.details?.collection || {};

  if (!url) return null;
  if (!showCollection) return null;

  const collectionClasses = classNames('product-details__moreCollection', {
    'product-details__moreCollection--mobile': channel === 'mobile'
  });

  return (
    showCollection
    && (
      <a
        className={collectionClasses}
        href={url}
        onClick={(event) => analyticsData(event, pageType, 'more in this collection')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {link && <span> Shop this Collection </span>}
        {!link && <span> Shop the Collection </span>}
      </a>
    )
  );
};

CollectionURL.propTypes = {
  link: bool,
  pageType: string,
  showCollection: bool
};

CollectionURL.defaultProps = {
  link: false,
  pageType: 'PEP',
  showCollection: true
};

const ProductDetailsBrandCollection = ({ link, pageType, showCollection, showBrandHyperLink }) => {

  const { channel } = useContext(ExperienceContext);
  const { product } = useContext(ProductDetailsContext);
  const { identifiers, taxonomy } = product || {};
  const { brandLinkUrl } = taxonomy || {};
  const { brandName } = identifiers || {};
  const isMobile = channel === 'mobile';
  const brandClass = classNames({
    'product-details__brand--mobile': isMobile
  });
  const brandNameClasses = classNames('product-details__brand-name', {
    'product-details__brand-name--mobile': isMobile && pageType === 'PEP'
  });
  const byTextClasses = classNames({
    'product-details__by--mobile': isMobile && pageType === 'PEP',
    'product-details__by': !(isMobile && pageType === 'PEP')
  });

  const { itemId } = product;
  const brandRef = useRef();

  if (!taxonomy && !showCollection) return null;
  return (
    <div className="product-details__brand-collection">
      {brandName && brandLinkUrl && (
        <div className={brandClass} ref={brandRef}>
          <a
            className="product-details__brand"
            href={brandLinkUrl}
            onClick={(event) => analyticsData(event, pageType, 'clickable brand link')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <span>
              {showBrandHyperLink && <h2 className="product-details__brand--link">{brandName}</h2>}
              {!showBrandHyperLink
                && (
                  <>
                    <span className={byTextClasses}>by </span>
                    <h2 className={brandNameClasses}>{brandName}</h2>
                  </>
                )}
            </span>
          </a>
          {isMobile && brandName ? (
            <span className="product-details__brand-rating--mobile">
              <BrandRating
                channel={channel}
                brandName={brandName}
                itemId={itemId}
                parentNode={brandRef.current}
              />
            </span>
          ) : ''}
          {isMobile && brandName && showCollection
          && <CollectionURL channel={channel} link={link} product={product} showBrandHyperLink={showBrandHyperLink} />}
        </div>
      )}
      {!isMobile && brandName && showCollection
      && <CollectionURL channel={channel} link={link} product={product} showBrandHyperLink={showBrandHyperLink} />}
      {!isMobile && brandName ? (
        <BrandRating
          channel={channel}
          brandName={brandName}
          itemId={itemId}
          parentNode={brandRef.current}
        />
      ) : ''}
    </div>
  );
};

ProductDetailsBrandCollection.propTypes = {
  link: bool,
  pageType: string,
  showCollection: bool,
  showBrandHyperLink: bool
};

ProductDetailsBrandCollection.defaultProps = {
  link: false,
  pageType: 'PEP',
  showCollection: false,
  showBrandHyperLink: false
};

ProductDetailsBrandCollection.dataModel = extend(BrandRating);

export default ProductDetailsBrandCollection;
